<template>
  <div
    style="display: flex; flex-direction: column;"
  >
    <div style="font-weight: 800;">
      {{ $t('controller.importCSVFile') }}
    </div>
    <VFileDragAndDrop
      :file="fileSelected"
      :mimes="['text/csv']"
      autoUpload
      @onChange="onchangeFile"
    />
    <div
      style="display: flex; flex-direction: row; justify-content: space-between; width: 100%;"
    >
      <div>{{ $t('controller.fileSupported') }}</div>
      <div>{{ $t('controller.maximalSize', { maxFileSize: '25MB' }) }}</div>
    </div>

    <div
      v-if="fileSelected.name"
      style="margin-top: 20px;"
    >
      <VTextField
        v-model="fileSelected.name"
        outlined
        clearable
        @click:clear="customClearFunction"
      />
    </div>

    <div
      v-if="fileSelected.name && tested"
    >
      <TestFormCSVThumbnail
        v-for="item in checkList"
        :key="item"
        :testValue="checkedItem[item]"
        :name="item"
        :controllerId="controllerId"
        :controllerIdInFile="itemsExtractedInFile.controllerId"
        :missingProbes="itemsExtractedInFile.missingProbes"
        :dateFormat="dateFormat"
        :dateFormatInFile="itemsExtractedInFile.dateFormat"
      />
    </div>
    <div
      style="display: flex; flex-direction: row; justify-content: flex-end;"
      class="mt-4"
    >
      <v-btn
        :disabled="(tested && !CSVFileIsCorrect) || !fileSelected.name ? true : false"
        color="primary"
        type="submit"
        class="capitalize large"
        data-cy="buttonNext"
        style="width: 100px;"
        @click.prevent="tested ? closeModal() : onClickTest()"
      >
        {{ textButton }}
      </v-btn>
    </div>

    <div
      v-if="tested"
      :style="{
        marginTop: '20px',
        backgroundColor: CSVFileIsCorrect ? 'green' : 'red',
        color: 'white',
        fontWeight:500,
        borderRadius: '4px',
        paddingTop: '6px',
        paddingBottom: '6px',
      }"
    >
      <div
        v-if="CSVFileIsCorrect"
        style="display: flex; flex-direction: row;"
      >
        <v-icon
          color="white"
          style="margin-right: 10px; margin-left: 10px; "
        >
          mdi-checkbox-marked-circle
        </v-icon>
        <div>
          <div> {{ $t('controller.success') }} </div>
          <div>
            {{ $t('controller.verificationText.messageSuccess') }}
          </div>
        </div>
      </div>
      <div
        v-else
        style="display: flex; flex-direction: row;"
      >
        <v-icon
          color="white"
          style="margin-right: 10px; margin-left: 10px; "
        >
          mdi-close-circle
        </v-icon>
        <div>
          <div> {{ $t('controller.error') }} </div>
          <div>
            {{ $t('controller.verificationText.messageFailure') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VFileDragAndDrop from '@/components/shared/widgets/forms/VuetifyInputs/VFileDragAndDrop';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import moment from 'moment';
import TestFormCSVThumbnail from './TestFormCSVThumbnail.vue';


export default {
    name: 'TestCSVForm',
    components: {
        VFileDragAndDrop,
        VTextField,
        TestFormCSVThumbnail,
    },

    props: {
        controllerId: {
            type: String,
            required: true,
        },
        dateFormat: {
            type: String,
            required: true,
        },
        probesIds: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            fileSelected: '',
            fileName: '',
            tested: false,

            checkedItem: {
                controllerId: false,
                probeId: false,
                dateFormat: false,
            },
            itemsExtractedInFile: {
                controllerId: '',
                missingProbes: [],
                dateFormat: '',
            },


        };
    },

    computed: {
        checkList() {
            return ['controllerId', 'probeId', 'dateFormat'];
        },
        CSVFileIsCorrect() {
            return this.checkedItem.probeId && this.checkedItem.dateFormat && this.checkedItem.controllerId;
        },
        textButton() {
            if (this.tested && this.CSVFileIsCorrect) {
                return this.$t('confirm');
            }
            return this.$t('controller.test');
        },
    },
    methods: {
        onchangeFile(file) {
            this.fileSelected = file;
        },

        async onClickTest() {
            const file = await this.readFile();
            this.testControllerId(file);
            this.testProbeId(file);
            this.testDateFormat(file);
            this.tested = true;
        },


        customClearFunction() {
            this.resetFile();
        },
        resetFile() {
            this.fileSelected = '';
            this.fileName = '';
            this.tested = false;
        },

        async readFile() {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = () => {
                    reject(new Error('Erreur lors de la lecture du fichier'));
                };
                if (!this.fileSelected) {
                    reject(new Error('Aucun fichier sélectionné'));
                    return;
                }
                reader.readAsText(this.fileSelected);
            });
        },

        async testControllerId(file) {
            if (file && file.trim()) {
                const firstLine = file.split('\n')[0].trim();
                // only get number from the first line(which is the controllerId)
                const clean = firstLine.match(/^[^,]+/)?.[0] ?? '';
                this.itemsExtractedInFile.controllerId = clean;

                if (clean === this.controllerId) {
                    this.checkedItem.controllerId = true;
                } else {
                    this.checkedItem.controllerId = false;
                }
            } else {
                this.checkedItem.controllerId = false;
            }
        },

        async testProbeId(file) {
            try {
                if (!this.probesIds || !Array.isArray(this.probesIds) || this.probesIds.length === 0) {
                    this.checkedItem.probeId = false;
                    return;
                }

                const lines = file.split('\n').map(line => line.trim()).filter(line => line); // Divise en lignes

                if (lines.length < 3) {
                    this.checkedItem.probeId = false;
                    return;
                }
                const searchLines = lines.slice(1, -1);

                const allFields = [];
                searchLines.forEach(line => {
                    const fields = line.split(',').map(field => field.trim());
                    allFields.push(...fields);
                });

                const missingProbes = this.probesIds.filter(probeId => !allFields.some(field => field.includes(probeId)));

                this.checkedItem.probeId = missingProbes.length === 0;

                this.itemsExtractedInFile.missingProbes = missingProbes;
            } catch (error) {
                this.checkedItem.probeId = false;
            }
        },


        async testDateFormat(file) {
            try {
                if (!this.dateFormat) {
                    this.checkedItem.dateFormat = false;
                    return;
                }
                const lines = file.split('\n').map(line => line.trim()).filter(line => line);
                const lastLine = lines[lines.length - 1];
                const lastDate = lastLine.split(' ')[0].trim();
                if (!lastDate) {
                    this.checkedItem.dateFormat = false;
                    this.itemsExtractedInFile.dateFormat = '';
                    return;
                }

                this.itemsExtractedInFile.dateFormat = lastDate;

                const isValidDate = moment(lastDate, this.dateFormat).isValid();
                this.checkedItem.dateFormat = isValidDate;
            } catch (error) {
                this.checkedItem.dateFormat = false;
            }
        },
        closeModal() {
            this.$emit('hide');
        },


    },
};
</script>
